/*
	Abre o menu
*/
export default ({ commit }) => 
	commit("openMenu")

